import axios from "./productInstance";
import { PriceModel } from "@/types/product";

const getPrices = async (page: number = 1, size: number = 100): Promise<PriceModel[] | null> => {
    try {



        const response = await axios.get(`/pricing/`, {
            params: { page, size },
        });

        return response.data.contents.map((model: PriceModel) => ({
            ...model,
            label: model?.name,
            value: model?.id,
        })) as PriceModel[];



    } catch (error) {
        console.error("Error fetching pricing data:", error);
        return null;
    }



};

export default getPrices;
